import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { TooltipComponent } from '@shared/tooltip/tooltip.component';
import { PageConflict } from '@models/discrepancy/page-conflict';

@Component({
    selector: 'app-page-range-conflict-error',
    imports: [MatIconModule, TooltipComponent],
    template: ` <p class="flex items-center">
        Page conflict.
        <app-tooltip>
            <mat-icon svgIcon="info" class="flex" trigger></mat-icon>
            <ul content class="pl-4">
                @for (conflict of data; track $index) {
                    <li>
                        Page <b>{{ conflict.pages.join(', ') }}</b> is specified
                        in Discrepancy {{ conflict.overlapsWith }}.
                    </li>
                }
            </ul>
        </app-tooltip>
    </p>`,
})
export class PageRangeConflictErrorComponent {
    @Input() data: PageConflict[] = [];
}
